import { useTheme } from '@emotion/react'
import { Chip } from '@mui/material'
import { SystemStatus } from '__generated__/graphql'
import startCase from 'lodash.startcase'
import { FC } from 'react'

interface Props {
    status?: SystemStatus | null
    statusDate?: string | null
    title?: string
    showLabel?: boolean
    sx?: React.CSSProperties
}

const formatStatusDate = (date: string): string => {
    const d = new Date(date)
    return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    })
}

const SystemStatusPill: FC<Props> = ({
    status,
    statusDate,
    title,
    showLabel,
    sx,
}) => {
    const theme = useTheme()
    const backgroundColor = (() => {
        switch (status) {
            case SystemStatus.Met:
                return theme.palette.status.blue
            case SystemStatus.SentScheduler:
                return theme.palette.status.bluegrey
            case SystemStatus.InProcess:
                return theme.palette.status.purple
            case SystemStatus.Unregistered:
                return theme.palette.status.pink
            case SystemStatus.OnHold:
                return theme.palette.status.orange
            case SystemStatus.EmailedInvitation:
                return theme.palette.status.teal
            case SystemStatus.NoStatus:
            default:
                return theme.palette.status.grey
        }
    })()

    const displayStatus = startCase(status || SystemStatus.NoStatus)
    const tooltip = statusDate
        ? `${displayStatus} · ${formatStatusDate(statusDate)}`
        : title || 'Registration Status'

    return (
        <Chip
            title={tooltip}
            size="small"
            label={showLabel ? `Registration: ${displayStatus}` : displayStatus}
            sx={{
                backgroundColor,
                color: theme.palette.greyscale.white,
                ...sx,
            }}
        />
    )
}

export default SystemStatusPill
